// Post-login destination from ?next= (or stashed before Google sign-in), only if it fits the role.
export function takeNextPath(role) {
  const fromUrl = new URLSearchParams(window.location.search).get("next");
  const next = fromUrl || sessionStorage.getItem("pgd.next") || "";
  sessionStorage.removeItem("pgd.next");
  const home = role === "admin" ? "/admin" : "/dashboard";
  if (!next.startsWith("/") || next.startsWith("//")) return home;
  const ok = role === "admin" ? next.startsWith("/admin") : /^\/(dashboard|notifications)/.test(next);
  return ok ? next : home;
}

export function stashNextPath() {
  const next = new URLSearchParams(window.location.search).get("next");
  if (next) sessionStorage.setItem("pgd.next", next);
}
